import React from 'react';
import { Hidden } from '@material-ui/core';
import Tooltip from '@cpg-its/ads.common.tooltip';
import { useHistory } from 'react-router';
import { BeneficiaryDto, PlanWithBeneficiary } from './model/beneficiary-models';
import { BeneficiarySettings } from './model/epi-props';
import { WysiwygWithReactLink } from '../../../../global/components/wysiwyg-with-react-link';
import { ContentSpacer } from '../../../../global/components/layout/generic-content-spacer';
import { DividerSection } from '../../../../global/components/layout/divider-section';
import { tcsmColors } from '../../../../global/constants/theme/theme-constants/colors';
import { BeneficiaryView } from './beneficiary-view';
import { labelSupplementStyles } from '../../../../global/constants/theme/styles/components/label-supplement-styles';
import { buttonStyles } from '../../../../global/constants/theme/styles/components/buttonstyles';
import { useBasePath } from '../../../../global/hooks/useBasePath';
import { AccountInfoRoutes } from '../../../account-info/constants/routes';
import { ArcRoutes } from '../../constants/routes';
import { filterBeneficiaryArrayToHaveUnique } from './helper/beneficiary-helper';


interface Props {
	planName: string;
	description: string;
	settings: BeneficiarySettings;
	beneficiaryPlan: PlanWithBeneficiary;
	defaultSpouse?: BeneficiaryDto;
	plan: string;
}
function BeneficiaryPlanView(props: Props) {

	const { planName, settings, beneficiaryPlan, defaultSpouse, description, plan } = props;
	const labelSupplementClasses = labelSupplementStyles();
	const buttonClasses = buttonStyles();
	const history = useHistory();
	const basePath = useBasePath(`${AccountInfoRoutes.MyCpgRoot}`);
	const primaryBenfiltered = filterBeneficiaryArrayToHaveUnique(beneficiaryPlan.primary);
	const contingentBenfiltered = filterBeneficiaryArrayToHaveUnique(beneficiaryPlan.contingent);


	function onUpdatePlan() {
		history.push(`${basePath}${ArcRoutes.Beneficiary}/${plan}`);
	}

	return (
		<DividerSection>
			<ContentSpacer>
				<ContentSpacer>
					<div className={labelSupplementClasses.labelLayout}>
						<h3>{planName}</h3>
						<div className='supplement-wrapper'>
							<Hidden smDown>
								<button className={buttonClasses.tertiaryButton} onClick={onUpdatePlan} type='button'>{settings?.updateButtonText}</button>
							</Hidden>
						</div>
					</div>
					<WysiwygWithReactLink content={description} />
				</ContentSpacer>
			</ContentSpacer>
			<ContentSpacer>
				<Hidden mdUp>
					<ContentSpacer>
						<button className={buttonClasses.tertiaryButton} onClick={onUpdatePlan} type='button'>{settings?.updateButtonText}</button>
					</ContentSpacer>
				</Hidden>
				<ContentSpacer>
					<div className={labelSupplementClasses.labelLayout}>
						<h3>{settings?.primaryBeneficiaryTitle}</h3>
						<div className='supplement-wrapper'>
							<Tooltip iconColor={tcsmColors.blue} title={settings?.primaryBeneficiaryHelperText} />
						</div>
					</div>
				</ContentSpacer>
				{
					defaultSpouse && beneficiaryPlan.primary?.length === 0 &&
					<BeneficiaryView beneficiary={defaultSpouse} settings={settings} isDesignated={false} />
				}
				{
					primaryBenfiltered?.map((beneficiary, idx) =>
						<BeneficiaryView key={idx} beneficiary={beneficiary} settings={settings} />,
					)
				}
				{
					beneficiaryPlan.primary?.length === 0 && !defaultSpouse &&
					<WysiwygWithReactLink content={settings?.noPrimaryBeneficirayMessage} />
				}
			</ContentSpacer>

			<ContentSpacer>
				<ContentSpacer>
					<div className={labelSupplementClasses.labelLayout}>
						<h3>{settings?.contingentBeneficiaryTitle}</h3>
						<div className='supplement-wrapper'>
							<Tooltip iconColor={tcsmColors.blue} title={settings?.contingentBeneficiaryHelperText} />
						</div>
					</div>
				</ContentSpacer>
				{
					beneficiaryPlan.contingent?.length > 0 ?
					contingentBenfiltered?.map((beneficiary, idx) =>
							<BeneficiaryView key={idx} beneficiary={beneficiary} settings={settings} />) :
						<WysiwygWithReactLink content={settings?.noContingentBeneficirayMessage} />
				}
			</ContentSpacer>
		</DividerSection>
	);
}

export default BeneficiaryPlanView;

BeneficiaryPlanView.defaultProps = {
	defaultSpouse: null,
};